module.exports = __webpack_public_path__ + "static/media/make_over.efc385f6.png";